module.exports = __webpack_public_path__ + "static/media/icon-embarcadiones-placer.7841d015.svg";